'use client';

import { APIPagination } from '@pioz/mlm-common';

export interface PaginationButtonsT {
  page: string;
  goToPage: string;
  loading: string;
  show: string;
}

export function PaginationButtons({
  pagination,
  maxPage,
  t,
}: {
  pagination: [APIPagination, (value: APIPagination) => void];
  maxPage: number;
  t: PaginationButtonsT;
}) {
  return (
    <div className="flex flex-col justify-end gap-3 pt-10 text-sm md:flex-row md:items-center md:text-base">
      <div className="flex items-center gap-2">
        <span className="flex items-center gap-1">
          <div className="hidden md:block">{t.page}</div>
          <strong>
            {pagination[0].pageIndex + 1} of {maxPage}
          </strong>
        </span>
        <span className="flex items-center gap-1">
          | {t.goToPage}:
          <input
            type="number"
            defaultValue={pagination[0].pageIndex + 1}
            onChange={(e) => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0;
              pagination[1]({ ...pagination[0], pageIndex: page });
            }}
            className="input input-sm md:input-md w-16"
          />
        </span>
        <select
          className="select select-sm md:select-md"
          value={pagination[0].pageSize}
          onChange={(e) => {
            pagination[1]({ ...pagination[0], pageSize: Number(e.target.value) });
          }}
        >
          {[20, 30, 40, 50].map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              {t.show} {pageSize}
            </option>
          ))}
        </select>
      </div>
      <div className="flex items-center gap-2">
        <button
          className="btn btn-square btn-outline btn-primary btn-sm md:btn-md"
          onClick={() => {
            if (pagination[0].pageIndex === 0) return;
            pagination[1]({ ...pagination[0], pageIndex: 0 });
          }}
          disabled={pagination[0].pageIndex === 0}
        >
          {'<<'}
        </button>
        <button
          className="btn btn-square btn-outline btn-primary btn-sm md:btn-md"
          onClick={() => {
            if (pagination[0].pageIndex === 0) return;
            pagination[1]({ ...pagination[0], pageIndex: pagination[0].pageIndex - 1 });
          }}
          disabled={pagination[0].pageIndex === 0}
        >
          {'<'}
        </button>
        <button
          className="btn btn-square btn-outline btn-primary btn-sm md:btn-md"
          onClick={() => {
            if (maxPage && pagination[0].pageIndex + 1 >= maxPage) return;
            pagination[1]({ ...pagination[0], pageIndex: pagination[0].pageIndex + 1 });
          }}
          disabled={pagination[0].pageIndex + 1 >= maxPage}
        >
          {'>'}
        </button>
        <button
          className="btn btn-square btn-outline btn-primary btn-sm md:btn-md"
          onClick={() => {
            pagination[1]({ ...pagination[0], pageIndex: maxPage - 1 });
          }}
          disabled={pagination[0].pageIndex + 1 >= maxPage}
        >
          {'>>'}
        </button>
      </div>
    </div>
  );
}
